import { transition, trigger } from '@angular/animations';
import { fadeInUp, slideToRight } from '@libs/shared/animation/animation';
import {
  DurationToken,
  EasingToken,
} from '@libs/shared/animation/animation-token';

export const routeAnimations = trigger('routeAnimations', [
  transition('ExpertProgramBoard => NewExpertProgram', [
    ...fadeInUp(DurationToken.medium2, EasingToken.standard),
  ]),
  transition('NewExpertProgram => ExpertProgramBoard', [
    ...slideToRight(DurationToken.medium2, EasingToken.standard),
  ]),
  transition('ExpertProgramBoard => ExpertProgram', [
    ...fadeInUp(DurationToken.medium2, EasingToken.standard),
  ]),
  transition('ExpertProgram => ExpertProgramBoard', [
    ...slideToRight(DurationToken.medium2, EasingToken.standard),
  ]),
  transition('ExpertProgram => ExpertProgramInvitation', [
    ...fadeInUp(DurationToken.medium2, EasingToken.standard),
  ]),
  transition('ExpertProgramInvitation => ExpertProgram', [
    ...slideToRight(DurationToken.medium2, EasingToken.standard),
  ]),
  transition('NewExpertProgram => ExpertProgramInvitation', [
    ...fadeInUp(DurationToken.medium2, EasingToken.standard),
  ]),
]);
